<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <header-list
                    :title="pageTitle"
                    :placeholderSearch="searchPlaceholder"
                    v-model="query"
                    :routeAddName="`${moduleCode}.${pageID}.create`"
                    :routeAddParams="{ type: 'item' }"
                    :canAdd="canAdd"
                    :addTitle="addItemTitle"
                    :icon="icon"
                    @search="onSearch">
                    <template v-slot:buttons-right v-if="canAdd">
                        <router-link
                            v-html="addGroup"
                            class="btn btn-main btn-rounded btn-sm min-w-auto my-0 px-3 d-flex flex-row align-items-center justify-content-center flex-nowrap d-sm-inline"
                            :to="{ name: `${moduleCode}.${pageID}.create`, params: { type: 'group' } }">
                        </router-link>
                    </template>
                </header-list>

                <div class="row">
                    <div class="col">
                        <recursive-list
                            :list="list"
                            :checkActions="checkActions"
                            :moduleId="moduleId"
                            :routeGroupEdit="`${moduleId}.${pageID}.show.group`"
                            :routeItemEdit="`${moduleId}.${pageID}.show.item`"
                            :canDetail="canDetail"
                            :canEdit="canEdit"
                            :canDelete="canDelete"
                            :onRemove="onRemove"
                            :deleteItem="deleteItem"
                            :table="table"
                            :showError="showError"
                            :pageCode="pageID"
                            :targetField="'layers'"
                        >
                        </recursive-list>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
import GeneralMixin from './mixins/GeneralMixin'

export default {
    name: 'RegulationList',
    mixins: [
        GeneralMixin
    ],
    props: {
        id: {
            type: String,
            required: true,
        },
        columnParentId: {
            type: String,
            default: 'parent_id',
        },
        columnChildrens: {
            type: String,
            default: 'children',
        },
        addItemTitle: {
            type: String,
            default: 'global.add',
        },
        routeGroupKey: {
            type: String,
            default: 'group',
        },
        routeItemKey: {
            type: String,
            default: 'item',
        }
    },
    components: {
        RecursiveList: () => import(/* webpackChunkName: "recursive-list" */ './RecursiveList'),
    },
    data() {
        return {
            pageID: null,
            pageTitle: 'List',
            table: {
                showPagination: false,
                tableInline: true,
            },
        }
    },
    beforeMount() {
        this.pageID = this.id;
    },
    computed: {
        addGroup() {
            return `<i class="fas fa-plus"></i> ${this.$t('global.group')}`
        },
        icon() {
            return 'fas fa-plus'
        },
        numGroups() {
            return this.list.filter( item => item[this.columnParentId]==null).length;
        },
        tableColumns() {
            return [
                {
                    label: `${this.pageID}.model.name`,
                    field:  'name',
                    sortable: false,
                },
                {
                    label: '',
                    field:  null,
                    sortable: false,
                    class: 'actions',
                }
            ];
        },
    },
    methods: {
        onRemove: function(id, data){
            this.loadData();
        },
    }
}
</script>

<style>

</style>